import { render, staticRenderFns } from "./dahuascale.vue?vue&type=template&id=ccb5b514&scoped=true&"
import script from "./dahuascale.vue?vue&type=script&lang=js&"
export * from "./dahuascale.vue?vue&type=script&lang=js&"
import style0 from "./dahuascale.vue?vue&type=style&index=0&id=ccb5b514&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb5b514",
  null
  
)

export default component.exports